import * as React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

interface GoogleMapsProviderProps {
  children: React.ReactNode;
}

/**
 * GoogleMapsProvider - Centralized Google Maps API provider for React 18
 *
 * This provider uses @vis.gl/react-google-maps (Google's official React library)
 * to load the Google Maps API once at the app level. This is the recommended
 * approach for React 18 and prevents duplicate script loading issues.
 *
 * All map components (EntitiesMap, EnhancedEntityMap, etc.) should be
 * children of this provider.
 *
 * Libraries loaded:
 * - geometry: For EntitiesMap marker spreading calculations
 * - places: For GoogleMapsAutoComplete address search
 */
export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
  return (
    <APIProvider apiKey={process.env.REACT_APP_MAP_API || ''} libraries={['geometry', 'places']}>
      {children}
    </APIProvider>
  );
};
